if (!customElements.get('fancybox-gallery')) {
  customElements.define(
    'fancybox-gallery',
    class FancyboxGallery extends HTMLElement {
      constructor() {
        super();
        this.groupName = this.querySelector('[data-fancybox]')?.dataset?.fancybox;
        this.anchor = this.groupName ? `[data-fancybox="${this.groupName}"]` : null;
      }

      connectedCallback() {
        if (Shopify?.designMode || !this.anchor) return;
        this.initFancybox();
      }

      initFancybox() {
        if (!this.anchor) return;
        Fancybox.bind(this, this.anchor, {
          Hash: false,
          closeExisting: true,
          groupAll: true,
          zoom: false,
          keyboard: {
            Escape: 'close',
            Delete: 'close',
            Backspace: 'close',
            PageUp: 'next',
            PageDown: 'prev',
            ArrowUp: 'prev',
            ArrowDown: 'next',
            ArrowRight: 'next',
            ArrowLeft: 'prev',
          },
          Carousel: {
            Thumbs: false,
            Toolbar: {
              absolute: true,
              display: {
                left: ['counter'],
                right: ['close'],
              },
            },
          },
          theme: 'auto',

          on: {
            done: (fancybox) => {
              const el = fancybox.container;
              el.classList.add(
                'fancybox-show-toolbar',
                'fancybox-show-infobar',
                'fancybox-show-nav'
              );
            },
            afterSettle: (fancybox) => {
              const el = fancybox.container;
              el.classList.add(
                'fancybox-show-toolbar',
                'fancybox-show-infobar',
                'fancybox-show-nav'
              );
            },
          },
        });
      }
    }
  );
}
